var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"loading-overlay\" ng-class=\"{ 'loading': $ctrl.loadingOverlayService.isLoading }\"> <div class=\"loading-overlay-logo\"> <span class=\"loading-overlay-line-1\" ng-i18next> common.portal_loading_row_1 </span>\n<span class=\"loading-overlay-line-2\" ng-i18next> common.portal_loading_row_2 </span> </div> </div>";
var id1="loadingOverlay.html";
ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);
module.exports=v1;


//////////////////
// WEBPACK FOOTER
// ./src/core/loadingOverlay.html
// module id = 69
// module chunks = 0 2